/**
 * @ngdoc service
 * @name checkins.factory:sendSms
 *
 * @description
 *
 */

import templateUrl from '../../views/workflows/sms-modal.tpl.html';

class SmsModalCtrl {

    constructor($uibModalInstance, $scope, $injector) {
        this.modal = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;
        this.api = $injector.get('$http');

        this.sender_names = _.get(this.injector.get('Users').state.loggedin.profile.company.data, 'settings.messages.sms_sender_names', []);
        this.message = {
            type: 'sms',
            content: '',
            sender_name: this.sender_names[0] ? this.sender_names[0].value : null
        };

        this.selectedSmsTemplateId = null
        this.selectedSmsTemplate = null;

        $scope.$watch(() => this.selectedSmsTemplateId, () => {
            if(!this.selectedSmsTemplateId) {
                this.selectedSmsTemplate = null
                return
            }

            this.api.get(`messages/sms/templates/${this.selectedSmsTemplateId}`)
                .then((response) => {
                    this.selectedSmsTemplate = response.data.data

                    this.message.content = this.selectedSmsTemplate.content;
                    this.message.sender_name = this.selectedSmsTemplate.from_number;
                })
        })

        this.smsTemplateSelectConfig =  {
            store: this.injector.get('SmsTemplates').reset({
                persist: false,
                listview: 'SendSmsTemplatesSelect'
            }),
            valueField: 'id',
            displayField: 'name',
            maxItems: 1
        };

        this.messageValidation = {
            isGsm: true,
            limit: 140,
            length: 0,
            smsCount: 0
        };

        this.scope.$watch(() => this.message.content, () => {
            let gsm = "@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞ^{}\[~]|€ÆæßÉ!\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà\n ",
                gsmDoubleBytes = '€~{}[]^|\\',
                gsmCheck = true,
                strLengthPerChar = 0,
                strLengthGsm = 0;

            for (let i = 0, n = this.message.content.length; i < n; i++) {
                strLengthPerChar++;
                strLengthGsm++;
                let curChar = this.message.content[i];
                if (gsm.indexOf(curChar) !== -1) {
                    if (gsmDoubleBytes.indexOf(curChar) !== -1) {
                        strLengthGsm++;
                    }
                } else {
                    gsmCheck = false;
                }
            }

            if (gsmCheck) {
                this.messageValidation = {
                    isGsm: true,
                    limit: 140,
                    length: strLengthGsm,
                    smsCount: (strLengthGsm > 0) ? Math.ceil(strLengthGsm / 140) : 0
                };
            } else {
                this.messageValidation = {
                    isGsm: false,
                    limit: 70,
                    length: strLengthPerChar,
                    smsCount: (strLengthPerChar > 0) ? Math.ceil(strLengthPerChar / 70) : 0
                };
            }
        });

        this.aceOptions = {};
        this.injector.get('AceEditor').getEditor((editor) => this.aceOptions = editor);
    }

    send() {
        this.modal.close(this.message);
    }

    cancel() {
        this.modal.dismiss('cancel');
    }
}

function sendSms(Alert, locale, $http, $uibModal) {
    return {
        key: 'send-sms',
        title: 'Send SMS',
        level: 'selected',
        action({}, store) {

            $uibModal.open({
                animation: true,
                size: 'md',
                templateUrl: templateUrl,
                controller: ['$uibModalInstance', '$scope', '$injector', SmsModalCtrl],
                controllerAs: 'vm'
            }).result.then(message => {
                message[store.state.slug] = store.getters.selectedFilters;
                message.recipient_type = store.state.type;
                return locale.ready('sweetalerts')
                    .then(() => {
                        return $http.post('messages/', message)
                            .then(response => {
                                store.dispatch('getData');
                                Alert.success('Message Sent', 'Your message has been queued for sending');
                            }, response => Alert.handle(response));
                    });
            }, response => Alert.handle(response));

        }
    }
}


angular
    .module('festzelt-os.contacts')
    .factory('sendSms', [
        'Alert',
        'locale',
        '$http',
        '$uibModal',
        sendSms
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/send-sms.js